import React from 'react';

const SofincoLogo = ({ className = "h-10", white = false }) => {
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_younited-clone-1/artifacts/y6hpz6h2_IMG_0359.jpeg"
      alt="Younited"
      className={`object-contain ${className}`}
      style={white ? { filter: 'brightness(0) invert(1)' } : {}}
    />
  );
};

export default SofincoLogo;
